// extracted by mini-css-extract-plugin
export default {"container":"YZ-z","heading":"ZZ-z","links":"_Z-z","copy":"a0-z","subCopy":"b0-z","linksLeft":"c0-z","linksCenter":"d0-z","linksRight":"e0-z","link":"f0-z","onlyLink":"g0-z"};